import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SingleSelect from '../../common/Forms/SingleSelect';
import { BackgroundSet, Background } from "../../../models";
import Image from '../../Image/Image'
import styles from './BackgroundSelect.module.sass'

const BackgroundSelect = ({ options, backgroundSet }) => {
  const [selectedOption, setSelectedOption] = useState(backgroundSet);
  const [backgrounds, setBackgrounds] = useState([]);

  useEffect(() => {
    async function getData() {
      const backgroundSetRes = await BackgroundSet
        .includes('backgrounds')
        .find(selectedOption.value)

      const { data: backgroundSet } = backgroundSetRes

      setBackgrounds(backgroundSet.backgrounds);
    }

    if (selectedOption.value) {
      getData()
    }
  }, [selectedOption])

  const handleChange = (option) => {
    setSelectedOption(option || {});
  };

  const renderBackgrounds = () => {
    if (!selectedOption) return;

    return (
      <div className={styles.backgroundContainer}>
        {backgrounds.map((background) => {
          return (
            <Image src={background.imageUrl} />
          )
        })}
      </div>
    )
  }

  return (
    <div style={ { width: '600px' } }>
      <input name="package[background_set_id]"
             value={selectedOption && selectedOption.value || ''}
             hidden
      />
      <SingleSelect
        handleChange={handleChange}
        options={options}
        selectedValue={selectedOption}
        placeholderText='Select Background Set'
      />
      {renderBackgrounds()}
    </div>
  );
};

BackgroundSelect.propTypes = {
  options: PropTypes.array,
  selectedValues: PropTypes.array
};

BackgroundSelect.defaultProps = {
  options: [{}],
  selectedValues: [{}]
};

export default BackgroundSelect;
